import request from '../request';
/*
 */
export const withDrawApi = {

  /**
   * 资金账户列表
   */
  get (params) {
    return request({
      url: `/gw/w/withdraw/records`,
      method: 'get',
      params,
    });
  },
  getAccountBySymbol (symbol) {
    return request({
      url: `/api/w/exchange/account/${symbol}`,
      method: 'get',
    });
  },

  getAccountByPair (symbol) {
    return request({
      url: `/api/w/exchange/account/pair/${symbol}`,
      method: 'get',
    });
  },
  cancelWithdrawal (symbol) {
    return request({
      url: `/gw/w/withdraw/${symbol}`,
      method: 'delete',
    });
  },
};
